import { LayoutDefault } from '@/components/layouts'

export const turtasRoute = [
  {
    path: '*',
    // component: () => import('@/views/error/NotFound.vue'),
    redirect: { name: 'home' },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/auth/Login.vue'),
    meta: {
      title: 'Login',
      open: true,
    },
    hidden: true,
  },
  {
    path: '/ipasas',
    name: 'ipasasAuth',
    meta: {
      title: 'iPAS',
      open: true,
    },
    component: () => import('@/views/auth/IpasasAuth.vue'),
  },
  {
    path: '/sutikimas',
    name: 'sutikimas',
    meta: {
      title: 'Sutikimas su sąlygomis',
      open: true,
    },
    component: () => import('@/views/auth/Sutikimas.vue'),
  },
  {
    path: '/sign/:objektasID',
    name: 'sign',
    redirect: to => ({
      name: 'hipotekaRegistravimas',
      params: { ...to.params, sign: true },
    }),
  },
  {
    path: '/ntr-sign/:prasymasID',
    name: 'ntrsign',
    redirect: to => ({
      name: 'regPrasymasRegistravimas',
      params: { ...to.params, sign: true },
    }),
  },
  {
    path: '/paieska-sign/:paieskaID',
    name: 'paieskasign',
    redirect: to => ({
      name: 'paieskaTvirtinimas',
      params: { ...to.params, sign: true },
    }),
  },
  {
    path: '/xsdschema',
    name: 'XSDSchemaList',
    meta: {
      title: 'xsd schema',
      open: true,
    },
    component: () => import('@/views/XSDSchemaList.vue'),
  },
  {
    path: '/xsdschema/:xsdName',
    name: 'XSDSchema',
    meta: {
      title: 'xsdschema',
      open: true,
    },
    component: () => import('@/views/XSDSchema.vue'),
  },
  {
    path: '/xmldescription/:xmlName',
    name: 'XMLDescription',
    meta: {
      title: 'xmldescription',
      open: true,
    },
    component: () => import('@/views/XMLDescription.vue'),
  },
  {
    path: '/gautas-pranesimas/:pranesimas',
    name: 'gautasPranesimas',
    meta: {
      title: 'Gautas pranešimas',
      open: true,
    },
    component: () => import('@/views/GautasPranesimas.vue'),
  },
  {
    path: '/migris-web',
    name: 'migrisWeb',
    meta: {
      title: 'Migris Web',
      open: true,
    },
    component: () => import('@/views/MigrisWeb.vue'),
  },

  {
    path: '/',
    name: 'home',
    component: LayoutDefault,
    meta: {
      title: 'Pagrindinis',
      group: 'apps',
    },
    redirect: { name: 'pagrindinis' },
    children: [
      {
        path: '/pagrindinis',
        name: 'pagrindinis',
        component: () => import('@/views/Pagrindinis.vue'),
        meta: {
          // title: 'Pagrindinis',
          group: 'apps',
        },
      },
      {
        path: '/nt-sandoris',
        name: 'ntSandoris',
        component: () => import('@/components/sandoris/Sandoris.vue'),
        meta: {
          title: 'Nekilnojamo turto sandoris',
          group: 'apps',
        },
      },
      {
        path: '/hipoteka',
        name: 'hipoteka',
        component: () => import('@/components/hipoteka/Hipoteka.vue'),
        meta: {
          title: 'Hipoteka / Įkeitimas',
          group: 'apps',
        },
      },
      {
        path: '/hipoteka/perleidimas',
        name: 'hipotekaPerleidimas',
        component: () =>
          import('@/components/perleidimas/HipotekaPerleidimas.vue'),
        meta: {
          title: 'Reikalavimo teisės perleidimas',
        },
      },
      {
        path: '/dokumentas/:objektasID',
        name: 'hipotekaTab',
        component: () => import('@/components/hipoteka/HipotekaTab.vue'),
        redirect: { name: 'hipotekaPranesimas' },
        meta: {
          title: ':hipotekaTipas',
        },
        children: [
          {
            path: 'dokumento-duomenys',
            name: 'hipotekaPranesimas',
            meta: {
              title: 'Dokumento duomenys',
            },
          },
          {
            path: 'duomenu-teikejas',
            name: 'hipotekaTeikejas',
            meta: {
              title: 'Duomenų teikėjas',
            },
          },
          {
            path: 'skolininkai',
            name: 'hipotekaSkolininkai',
            meta: {
              title: 'Skolininkai',
            },
          },
          {
            path: 'kreditoriai',
            name: 'hipotekaKreditoriai',
            meta: {
              title: 'Kreditoriai',
            },
          },
          {
            path: 'ikaito-davejai-hr',
            name: 'hipotekaIkaitoDavejaiHR',
            meta: {
              title: 'Įkaito davėjai iš HR',
            },
          },
          {
            path: 'turtas',
            name: 'hipotekaTurtas',
            meta: {
              title: ':turtasTitle',
            },
            children: [
              {
                path: ':turtasRusis/:turtasID',
                name: 'turtasObjektas',
                meta: {
                  title: 'Turtas',
                },
              },
            ],
          },
          {
            path: 'prievole',
            name: 'hipotekaPrievole',
            meta: {
              title: ':prievoleTitle',
            },
            children: [
              {
                path: ':prievoleID',
                name: 'prievoleObjektas',
                meta: {
                  title: 'Duomenys',
                },
              },
            ],
          },
          {
            path: 'sandoris',
            name: 'hipotekaSandoris',
            meta: {
              title: 'Sandorio informacija',
            },
          },
          {
            path: 'nustatymas',
            name: 'hipotekaNustatymas',
            meta: {
              title: 'Nustatymo informacija',
            },
          },
          {
            path: 'vykdomasis',
            name: 'hipotekaVykdomasis',
            meta: {
              title: 'Notaro vykdomasis įrašas',
            },
          },
          {
            path: 'salygos',
            name: 'hipotekaSalyginis',
            meta: {
              title: ':salyginisTitle',
            },
          },
          {
            path: 'kita-informacija',
            name: 'hipotekaKitaInfo',
            meta: {
              title: 'Kita informacija',
            },
          },
          {
            path: 'sutarties-salys',
            name: 'sutartisSalys',
            meta: {
              title: 'Sutarties šalys',
            },
          },
          {
            path: 'sutarties-informacija',
            name: 'sutartisInfo',
            meta: {
              title: 'Sutarties šalys',
            },
          },
          {
            path: 'sutarties-dalykas',
            name: 'sutartisDaiktas',
            meta: {
              title: 'Sutarties dalykas',
            },
          },
          {
            path: 'rinkmenos',
            name: 'hipotekaRinkmenos',
            meta: {
              title: 'Rinkmenos',
            },
          },
          {
            path: 'informavimas',
            name: 'hipotekaInformavimas',
            meta: {
              title: 'Informavimas',
            },
          },
          {
            path: 'registrui',
            name: 'hipotekaRegistravimas',
            meta: {
              title: 'Registravimas',
            },
          },
        ],
      },
      {
        path: '/zurnalas',
        name: 'zurnalasTab',
        component: () => import('@/components/zurnalas/ZurnalasTab.vue'),
        redirect: { name: 'zurnalasGaunami' },
        meta: {
          title: 'Dokumentų žurnalas',
          group: 'apps',
        },
        children: [
          {
            path: 'gaunami',
            name: 'zurnalasGaunami',
            meta: {
              title: 'Gauti duomenys',
            },
          },
          {
            path: 'ntr-gaunami',
            name: 'zurnalasNtrGaunami',
            meta: {
              title: 'Gauti NTR el. paslaugų duomenys',
            },
          },
          {
            path: 'siunciami',
            name: 'zurnalasSiunciami',
            meta: {
              title: 'Siųsti pranešimai',
            },
          },
          {
            path: 'ktpr-pranesimai',
            name: 'regitraPranesimai',
            meta: {
              title: 'Pranešimai apie TP',
            },
          },
          {
            path: 'dt-rengiami',
            name: 'teikejasRengiami',
            meta: {
              title: 'DT rengiami',
            },
          },
        ],
      },
      {
        path: '/sutartis',
        name: 'sutartis',
        component: () => import('@/components/sutartis/Sutartis.vue'),
        meta: {
          title: 'Neregistruojamų daiktų sutartis',
          group: 'apps',
        },
      },
      {
        path: '/rengiami-dokumentai',
        name: 'rengiamiDokumentaiTab',
        component: () =>
          import('@/components/sarasas/PranesimasRengiamiTab.vue'),
        redirect: { name: 'rengiamiDokumentaiHipoteka' },
        meta: {
          title: 'Rengiami dokumentai',
          group: 'apps',
        },
        children: [
          {
            path: 'hipotekos',
            name: 'rengiamiDokumentaiHipoteka',
            meta: {
              title: 'Hipotekos / Įkeitimai',
            },
          },
          {
            path: 'prasymai',
            name: 'rengiamiDokumentaiPrasymas',
            meta: {
              title: 'Prašymai dėl juridinių faktų',
            },
          },
        ],
      },
      {
        path: '/perduoti-dokumentai',
        name: 'perduotiDokumentaiTab',
        component: () =>
          import('@/components/sarasas/PranesimasPerduotiTab.vue'),
        redirect: { name: 'perduotiDokumentaiHipoteka' },
        meta: {
          title: 'Perduoti dokumentai',
          group: 'apps',
        },
        children: [
          {
            path: 'hipotekos',
            name: 'perduotiDokumentaiHipoteka',
            meta: {
              title: 'Hipotekos / Įkeitimai',
            },
          },
          {
            path: 'prasymai',
            name: 'perduotiDokumentaiPrasymas',
            meta: {
              title: 'Prašymai dėl juridinių faktų',
            },
          },
        ],
      },
      {
        path: '/paieska',
        name: 'paieskaTab',
        component: () => import('@/components/paieska/PaieskaTab.vue'),
        redirect: { name: 'paieskaJuridinis' },
        meta: {
          title: 'Paieška',
          group: 'apps',
        },
        children: [
          {
            path: 'juridinis',
            name: 'paieskaJuridinis',
            meta: {
              title: 'Pagal juridinį asmenį',
            },
          },
          {
            path: 'fizinis',
            name: 'paieskaFizinis',
            meta: {
              title: 'Pagal fizinį asmenį',
            },
          },
          {
            path: 'turtas',
            name: 'paieskaTurtas',
            meta: {
              title: 'Pagal turtą',
            },
          },
          {
            path: 'kodas',
            name: 'paieskaKodas',
            meta: {
              title: 'Pagal identifikacinį kodą',
            },
          },
          {
            path: 'mano-paieskos',
            name: 'paieskaMano',
            meta: {
              title: 'Mano paieškos',
            },
          },
          {
            path: 'tvirtinimas',
            name: 'paieskaTvirtinimas',
            meta: {
              title: 'Savitarnos užsakymai',
            },
          },
          {
            path: 'registruoti',
            name: 'paieskaRegistruoti',
            meta: {
              title: 'Registruotų naudotojų paieškos',
            },
          },
        ],
      },
      {
        path: '/prasymas-naujas',
        name: 'prasymasNaujas',
        component: () => import('@/components/prasymas/Prasymas.vue'),
        meta: {
          title: 'Prašymas dėl juridinio fakto',
          group: 'apps',
        },
      },
      {
        path: '/prasymas/:prasymasID',
        name: 'prasymasTab',
        component: () => import('@/components/prasymas/RegPrasymasTab.vue'),
        redirect: { name: 'regPrasymasDuomenys' },
        meta: {
          title: ':prasymasTipas',
        },
        children: [
          {
            path: 'dokumento-duomenys',
            name: 'regPrasymasDuomenys',
            meta: {
              title: 'Dokumento duomenys',
            },
          },
          {
            path: 'duomenu-teikejas',
            name: 'regPrasymasTeikejas',
            meta: {
              title: 'Duomenų teikėjas',
            },
          },
          {
            path: 'asmenys',
            name: 'regPrasymasAsmenys',
            meta: {
              title: 'Asmenys',
            },
          },
          {
            path: 'turtai',
            name: 'regPrasymasTurtas',
            meta: {
              title: 'Nekilnojamasis turtas',
            },
          },
          {
            path: 'sutartis',
            name: 'regPrasymasSutartis',
            meta: {
              title: 'Sutarties dokumento duomenys',
            },
          },
          {
            path: 'rinkmenos',
            name: 'regPrasymasRinkmenos',
            meta: {
              title: 'Rinkmenos',
            },
          },
          {
            path: 'informavimas',
            name: 'regPrasymasInformavimas',
            meta: {
              title: 'Informavimas',
            },
          },
          {
            path: 'registravimas',
            name: 'regPrasymasRegistravimas',
            meta: {
              title: 'Registravimas',
            },
          },
        ],
      },
      {
        path: '/archyvo-naikinimas',
        name: 'archyvoNaikinimas',
        component: () => import('@/components/naikinimas/NaikinimasTab.vue'),
        redirect: { name: 'naikinimasFormavimas' },
        meta: {
          title: 'Archyvo naikinimas',
        },
        children: [
          {
            path: 'formavimas',
            name: 'naikinimasFormavimas',
            meta: {
              title: 'Naikinimo akto formavimas',
            },
          },
          {
            path: 'aktas',
            name: 'naikinimasAktas',
            meta: {
              title: 'Naikinimas pagal aktą',
            },
          },
          {
            path: 'archyvaras',
            name: 'naikinimasArchyvaras',
            meta: {
              title: 'Naikinimo aktas archyvarui',
            },
          },
        ],
      },
      {
        path: '/admin',
        name: 'administravimas',
        component: () => import('@/components/admin/AdminTab.vue'),
        redirect: { name: 'adminAtaskaita' },
        meta: {
          title: 'Administravimas',
        },
        children: [
          {
            path: 'ataskaita',
            name: 'adminAtaskaita',
            redirect: { name: 'ataskaitaSusijusiems' },
            meta: {
              title: 'Ataskaitos',
            },
            children: [
              {
                path: 'susijusiems',
                name: 'ataskaitaSusijusiems',
                meta: {
                  title: 'Susijusiems registrams',
                },
              },
              {
                path: 'stsr',
                name: 'ataskaitaStsr',
                meta: {
                  title: 'Statistika STSR',
                },
              },
              {
                path: 'ntr',
                name: 'ataskaitaNtr',
                meta: {
                  title: 'Statistika NTR',
                },
              },
              {
                path: 'nep',
                name: 'ataskaitaNep',
                meta: {
                  title: 'NEP naudojamumas',
                },
              },
            ],
          },
          {
            path: 'parametrai',
            name: 'adminParametrai',
            meta: {
              title: 'Sistemos parametrai',
            },
          },
          {
            path: 'klasifikatoriai',
            name: 'adminKlasifikatoriai',
            meta: {
              title: 'Klasifikatoriai',
            },
          },
          {
            path: 'teises',
            name: 'adminTeises',
            meta: {
              title: 'NTR teisių tipai ir potipiai',
            },
          },
          {
            path: 'registrai',
            name: 'adminRegistrai',
            meta: {
              title: 'Rankinis duomenų įvedimas',
            },
          },
          {
            path: 'registravimas',
            name: 'adminRegistravimasAutomatu',
            meta: {
              title: 'Registravimas automatu',
            },
          },
          {
            path: 'siuntimo-administravimas',
            name: 'adminSiuntimoAdministravimas',
            meta: {
              title: 'Ataskaitų siuntimas',
            },
          },
          {
            path: 'taisykles',
            name: 'adminTaisykles',
            meta: {
              title: 'Susipažinimas su taisyklėmis',
            },
          },
          {
            path: 'tooltip',
            name: 'adminTooltip',
            meta: {
              title: 'Tooltips',
            },
          },
          {
            path: 'broker',
            name: 'adminBroker',
            meta: {
              title: 'RC Brokeris',
            },
          },
          {
            path: 'broker-list',
            name: 'adminBrokerList',
            meta: {
              title: 'RC Brokeris užklausos',
            },
          },
          {
            path: 'sistema-info',
            name: 'adminSistemaInfo',
            meta: {
              title: 'Sistemos informavimas',
            },
          },
          {
            path: 'zinute',
            name: 'adminZinute',
            meta: {
              title: 'Sistemos atnaujinimai',
            },
          },
          {
            path: 'generavimas',
            name: 'adminGeneravimas',
            meta: {
              title: 'PDF generavimas',
            },
          },
          {
            path: 'pas-tvarkymas',
            name: 'adminPasTvarkymas',
            meta: {
              title: 'Įvykdytas per PAS',
            },
          },
        ],
      },
      {
        path: '/zinutes',
        name: 'zinutes',
        component: () => import('@/components/sarasas/ZinuteList.vue'),
        meta: {
          title: 'Programos TURTAS atnaujinimai',
        },
      },
      {
        path: '/404',
        name: '404',
        meta: {
          title: 'Puslapis nerastas',
        },
        component: () => import('@/views/error/NotFound.vue'),
      },
      {
        path: '/500',
        name: '500',
        meta: {
          title: 'Serverio klaida',
        },
        component: () => import('@/views/error/Error.vue'),
      },
      {
        path: '/403',
        name: 'Deny',
        component: () => import('@/views/error/Deny.vue'),
        meta: {
          title: 'Prieiga uždrausta',
          hiddenInMenu: false,
        },
      },
    ],
  },
]
